// Libraries
import React from 'react';

// Components
import Layout from '../components/Layout';
import SEO from '../components/SEO';
import Masterclass from '../components/Masterclass';

const MasterclassPage = () => (
	<Layout>
		<SEO title="Transform My Wealth | Video Masterclass" />
		<Masterclass />
	</Layout>
);

export default MasterclassPage;
